import React, { ReactNode } from 'react';

import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

import TextField from './TextField';

interface CompProps {
    readonly fullWidth?: boolean;
    readonly label?: string;
    readonly placeholder?: string;
    readonly SelectProps?: any;
    readonly children: ReactNode;
    readonly value: string | number | string[];
    readonly name?: string;
    readonly onChange?: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
    readonly size?: 'medium' | 'small' | undefined;
    readonly tooltip?: string;
}

function SelectTextField({
    placeholder,
    SelectProps,
    children,
    value,
    ...otherProps
}: CompProps): JSX.Element {
    const classes = useStyles();

    const selectProps: { [key: string]: any } = {};
    // if (placeholder) {
    selectProps.displayEmpty = true;
    selectProps.renderValue =
        (value || '') !== ''
            ? undefined
            : () => <div className={classes.placeholder}>{placeholder ?? 'select an option'}</div>;
    // }
    selectProps.MenuProps = {
        classes: {
            paper: classes.menuPaper
        },
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        getContentAnchorEl: null
        // ...MenuProps // Not needed?
    };

    return (
        <TextField
            select
            SelectProps={{
                ...selectProps,
                ...SelectProps
            }}
            value={value}
            {...otherProps}>
            {children}
        </TextField>
    );
}

const useStyles = makeStyles((theme: Theme) => ({
    placeholder: {
        color: '#a9a9a9'
    },
    menuPaper: {
        margin: '4px 0px'
    }
}));

export default SelectTextField;
